import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import pic from "../../Assets/fssss.png";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import './Home.css';

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <div style={{ paddingBottom: 15 }}>
                <h1 className="heading hi">
                  Hi There!{" "}
                  <span className="waving-hand">👋</span>
                </h1>

                <h1 className="heading-name">
                  I'M
                  <strong className="main-name"> Faisal Imroz Heemel</strong>
                </h1>
              </div>

              <div id="type" className="type" style={{ paddingTop: 20 }}>
                <Type />
              </div>
            </Col>

            <Col md={5}>
              <img
                src={pic}
                alt="home pic"
                className="img-fluid home-image"
                style={{ maxHeight: "250px"}}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
